import { Component, OnInit, AfterViewInit } from "@angular/core";
//Import Custom Services Here
import { BalLoService } from "../report-services/bal-lo.service";
import { BalHiService } from "../report-services/bal-hi.service";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";

@Component({
	templateUrl: "./finesowedsummary.component.html",
})
export class FinesOwedSummaryComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private balhiService: BalHiService,
		private balloService: BalLoService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		//SchoolXML: "",
		BalLoID: 0,
		BalHiID: 0,
		SortByID: "Amount",
		StudentStatusID: "Active",
		ShowDetailID: "Yes",
		ImageLogo: "",
	};
	//Insert Custom Lists Here
	BalLoList: any = [];
	BalHiList: any = [];
	ImageLogoList: any = [];
	schoolList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList = [
		//Insert Custom List Items Here
		{
			SortByID: "Amount",
			SortByName: "Amount",
		},
		{
			SortByID: "Academy",
			SortByName: "Academy",
		},
		{
			SortByID: "Grade",
			SortByName: "Grade",
		},
		{
			SortByID: "Homeroom",
			SortByName: "Homeroom",
		},
		{
			SortByID: "Name",
			SortByName: "Name",
		},
	];

	StudentStatusList = [
		//Insert Custom List Items Here
		{
			StudentStatusID: "Active",
			StudentStatusName: "Active",
		},
		{
			StudentStatusID: "Inactive",
			StudentStatusName: "Inactive",
		},
		{
			StudentStatusID: "All",
			StudentStatusName: "All",
		},
	];

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailID: "Yes",
			ShowDetailName: "Yes",
		},
		{
			ShowDetailID: "No",
			ShowDetailName: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 156;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadBalLoList()
		// this.loadBalHiList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadBalLoList();
		this.loadBalHiList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(156);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}
	private loadBalLoList() {
		this.report.BalLoID = 0;
		var result = this.balloService.loadBalLoList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.BalLoList = response;

				if (this.BalLoList.length > 1) {
					// this.BalLoList.unshift({
					//     BalLoID: 0,
					//     BalLoDesc: "All BalLos"
					// })
					this.report.BalLoID = this.BalLoList[0].MinAmt;
				} else {
					this.report.BalLoID = this.BalLoList[0].MinAmt;
				}
			},
			(error) => {}
		);
	}

	private loadBalHiList() {
		this.report.BalHiID = 0;
		var result = this.balhiService.loadBalHiList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.BalHiList = response;

				if (this.BalHiList.length > 1) {
					// this.BalHiList.unshift({
					//     BalHiID: 0,
					//     BalHiDesc: "All BalHis"
					// })
					this.report.BalHiID = this.BalHiList[0].MaxAmt;
				} else {
					this.report.BalHiID = this.BalHiList[0].MaxAmt;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		// //Insert Custom Error Checks Here
		// if (!this.report.SchoolID) {
		// 	this.errorMessage = "Select the SchoolXML"
		// 	return;
		// }

		if (!this.report.BalLoID) {
			this.errorMessage = "Select the Minimum Balance";
			return;
		}

		if (!this.report.BalHiID) {
			this.errorMessage = "Select the Maximum Balance";
			return;
		}

		if (!this.report.SortByID) {
			this.errorMessage = "Select what to Sort By";
			return;
		}

		if (!this.report.StudentStatusID) {
			this.errorMessage = "Select the Student Status Option";
			return;
		}

		if (!this.report.ShowDetailID) {
			this.errorMessage = "Select the Show Detail Option";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 156;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolXML
		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>" + "|SchoolXML";

		//Parameter 2: BalLo
		strParam += "," + this.report.BalLoID + "|BalLo";

		//Parameter 3: BalHi
		strParam += "," + this.report.BalHiID + "|BalHi";

		//Parameter 4: SortBy
		strParam += "," + this.report.SortByID + "|SortBy";

		//Parameter 5: StudentStatus
		strParam += "," + this.report.StudentStatusID + "|StudentStatus";

		//Parameter 6: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		//Parameter 7: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
